// @ts-ignore
import request from '@/utils/request'
// @ts-ignore
import { v2Host } from '@/config/host'
import { AxiosPromise } from 'axios'
import type {
  AddProjectQuery,
  CopyProjectQuery,
  DeleteProjectQuery,
  EditProjectQuery,
  GetProjectListQuery,
  GetProjectListResponse,
  GetProjectInfoQuery,
  GetProjectInfoResponse,
  searchConfig,
  GetRelateProductQuery,
  GetProjectDetailResponse,
  NewProjectResponse,
  GetProjectListModel,
} from './type'
import type { _Response } from '../type'

export const getProjectList = (
  data: GetProjectListQuery,
): _Response<GetProjectListResponse> =>
  request({
    url: `${v2Host}/veditor/project/list`,
    method: 'get',
    params: data,
  })

// 获得详情
export const getProjectInfo = (
  data: GetProjectInfoQuery,
): _Response<GetProjectInfoResponse> =>
  request({
    url: `${v2Host}/veditor/project/info`,
    method: 'get',
    params: data,
  })

// 增加
export const addProject = (
  data: AddProjectQuery,
): _Response<NewProjectResponse> =>
  request({
    url: `${v2Host}/veditor/project/create`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
// 复制
export const copyProject = (
  data: CopyProjectQuery,
): _Response<NewProjectResponse> =>
  request({
    url: `${v2Host}/veditor/project/copy`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data, // cookRequestParams(data),
  })
// 修改名字
export const editProject = (data: EditProjectQuery): _Response<unknown> =>
  request({
    url: `${v2Host}/veditor/project/update`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data, // cookRequestParams(data),
  })
// 删除
export const deleteProject = (data: DeleteProjectQuery): _Response<unknown> =>
  request({
    url: `${v2Host}/veditor/project/delete`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })

// 获得关联产品的下拉框
export function productList(data?: Partial<searchConfig>): AxiosPromise {
  return request({
    url: `${v2Host}/advapp/product/list`,
    method: 'get',
    params: data,
  })
}

// 关联信息
export const getRelateProduct = (
  data: GetRelateProductQuery,
): _Response<unknown> =>
  request({
    url: `${v2Host}/veditor/project/relate-product`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data, // cookRequestParams(data),
  })

export const getProjectDetail = (
  data: GetProjectInfoQuery,
): _Response<GetProjectDetailResponse> =>
  request({
    url: `${v2Host}/veditor/project/detail`,
    method: 'get',
    params: data, // cookRequestParams(data),
  })

// 锁定项目
export const lockProject = (data: {
  pid: GetProjectListModel['id']
  locked: GetProjectListModel['locked']
}): _Response<unknown> =>
  request({
    url: `${v2Host}/veditor/project/lock`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })

// 重置 demo 项目
export const resetDemoProject = (data: { id: number }): _Response<unknown> => {
  // @ts-ignore
  return request({
    withoutError: true,
    url: `${v2Host}/veditor/project/reset-demo`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}
